// extracted by mini-css-extract-plugin
module.exports = {"container":"ZYrec","icon-spacer":"_1Mxxi","iconSpacer":"_1Mxxi","icon":"_34d7L","button":"_3KirZ"};